import { VISUALIZAR_LOADING, VISUALIZAR_MENU, VISUALIZAR_ALERTA } from '../actions/generales/actionTypes';

const configAlerta = { isVisible: false, tipo: '', titulo: '', mensaje: ''};

const ui = (state={isVisibleLoading: false, isVisibleMenu: false, configAlerta}, action) => {
    switch(action.type){
        case VISUALIZAR_LOADING:
            return {...state, isVisibleLoading: action.isVisibleLoading };
        case VISUALIZAR_MENU:
            return { ...state, isVisibleMenu: action.isVisibleMenu };
        case VISUALIZAR_ALERTA:
            return {...state, configAlerta: action.data };
        default:
            return state;
    }
};

export default ui;
